import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { 
  Copy, CheckCircle, Mail, Download, Building2, GraduationCap, Landmark, 
  Users, ExternalLink, Phone, MapPin, Crown, Globe, ChevronDown, ChevronUp,
  Target, Rocket, TrendingUp, Award, MessageCircle
} from "lucide-react";
import { Button } from "../components/ui/button";
import { InternalNav } from "../components/InternalNav";

// ========== TUTTI I DATI ==========

// AGENZIE FRANCHISING
const franchising = [
  { name: "Tecnocasa", agencies: "1.000+", email: "info@tecnocasa.it", phone: "02 66951", website: "tecnocasa.it" },
  { name: "Gabetti", agencies: "700+", email: "info@gabetti.it", phone: "06 68891", website: "gabetti.it" },
  { name: "Re/Max Italia", agencies: "400+", email: "info@remax.it", phone: "02 54107860", website: "remax.it" },
  { name: "Coldwell Banker", agencies: "150+", email: "info@coldwellbanker.it", phone: "02 87244700", website: "coldwellbanker.it" },
  { name: "Tempocasa", agencies: "600+", email: "info@tempocasa.it", phone: "02 26951", website: "tempocasa.it" },
  { name: "Toscano", agencies: "300+", email: "info@immobiliaretoscano.it", phone: "02 66101691", website: "immobiliaretoscano.it" },
];

// AGENZIE LUXURY
const luxury = [
  { name: "Lionard Luxury Real Estate", email: "info@lionard.com", phone: "+39 055 054 8100", location: "Firenze, Milano, Roma" },
  { name: "Engel & Völkers", email: "milano@engelvoelkers.com", phone: "+39 06 45548120", location: "Milano, Roma, Firenze" },
  { name: "Italy Sotheby's Realty", email: "info@sothebysrealty.it", phone: "+39 02 8707 8300", location: "Milano, Palermo" },
  { name: "Christie's Real Estate", email: "italy@christiesrealestate.com", location: "Network Italia" },
  { name: "Coldwell Banker Global Luxury", email: "luxury@coldwellbanker.it", phone: "+39 02 87244700", location: "Milano, Roma" },
];

// PORTALI ONLINE
const portali = [
  { name: "Idealista", email: "pro@idealista.it", phone: "02 36580315", note: "Leader Italia" },
  { name: "Immobiliare.it", email: "business@immobiliare.it", phone: "02 87159500", note: "56% traffico" },
  { name: "Casa.it", email: "info@casa.it", phone: "02 36580315", note: "Gruppo Idealista" },
  { name: "Homepal", email: "info@homepal.it", note: "Partner Intesa" },
];

// TOSCANA LOCALE
const toscana = [
  { name: "Valdelsa Immobiliare", location: "Colle Val d'Elsa", email: "info@valdelsaimmobiliare.it", phone: "0577 923291" },
  { name: "Max Abramo RE", location: "San Gimignano", email: "info@maxabramo.com", phone: "335 1676914" },
  { name: "Studio Montagliari", location: "Panzano", email: "cvoss@toskana.it", phone: "335 361872" },
  { name: "Geko Immobiliare", location: "San Gimignano", email: "info@gekoimmobiliare.com", phone: "331 2222793" },
  { name: "Immobiliare Chianti", location: "Radda", email: "info@immobiliarechianti.it" },
  { name: "Betti Toscana", location: "Siena", email: "info@bettitoscana.it", phone: "0577 935236" },
  { name: "Valdelsa Real Estate", location: "Poggibonsi", email: "valdelsarealestate@gmail.com", phone: "366 5999797" },
  { name: "Knight Frank Tuscany", location: "Radda", phone: "0577 738908" },
];

// REGIONE TOSCANA
const regioneToscana = [
  { name: "Sviluppo Toscana - Innovazione", email: "innovazione@sviluppo.toscana.it", phone: "055 2657550", note: "Bando Impresa Digitale 70%" },
  { name: "Sviluppo Toscana - Supporto", email: "supportoinnovazione@sviluppo.toscana.it", phone: "055 2657550", note: "Piattaforma SFT" },
  { name: "Punti Digitale Facile", website: "regione.toscana.it/-/punti-digitale-facile", note: "5 MLN € - Scad 30/09/2025" },
];

// FONDAZIONI
const fondazioni = [
  { name: "Fondazione CR Firenze", email: "info@fondazionecrfirenze.it", phone: "+39 055 5384001", bando: "Digitale Sociale 1,5 MLN €" },
  { name: "Fondazione MPS Siena", email: "fmps@fondazionemps.it", phone: "0577 246030", bando: "IKIGAI Borse 6.000€" },
];

// SCUOLE PNRR
const scuole = [
  { name: "IIS Sociali Siena", note: "Progetto DIGITAL@MENTE - Cercano formatori", website: "isisociali.edu.it" },
  { name: "USR Toscana", email: "direzione-toscana@istruzione.it", note: "Coordina PNRR scuole" },
  { name: "Scuola Futura Toscana", website: "scuolafutura.toscana.it", note: "Riparto DM 66" },
];

// EMAIL AGENZIE
const emailAgenzie = `OGGETTO: Proposta Virtual Tour 360° per [*NOME AGENZIA*] | schedabusiness.it

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

Gentile [*NOME RESPONSABILE*],

sono Riccardo Rossi, Fotografo Google Street View Certificato dal 2016.

I NUMERI:
• 87% utenti preferisce tour virtuali
• +42% richieste contatto
• -60% visite a vuoto

PACCHETTI:
| Pacchetto | Prezzo | Formazione       |
|-----------|--------|------------------|
| START     | €99    | +€199            |
| PLUS      | €299   | +€149            |
| ROOFTOP   | €599   | IN REGALO        |

✓ PayPal 3 rate (TAEG 0%)
✓ Deducibile 100%
✓ Pubblicazione Google Maps
✓ Timewarp Hyperlapse IN REGALO

DEMO: https://schedabusiness.it

Riccardo Rossi
WhatsApp: +39 327 383 9782
schedabusiness.it`;

// EMAIL ENTI
const emailEnti = `OGGETTO: Proposta Formazione Digitale Certificata Google - Deducibile 100% | PNRR/DM 66

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

Spett.le [*NOME ENTE*],
alla c.a. [*RESPONSABILE*]

Sono Riccardo Rossi, Fotografo Google Street View Certificato dal 2016.

NON sono un docente. Sono un professionista con:
• 7.000+ foto su Google Maps
• 52 MILIONI visualizzazioni
• 9 anni esperienza

📊 CONTESTO:
• Mercato e-Learning: 3 MILIARDI €
• Mismatch competenze: 44 MILIARDI €/anno
• PNRR DM 66: €122/ora

💼 PROPOSTA:
Formo studenti/dipendenti a diventare "Google Street View Trusted":
✓ Virtual Tour 360° con GoPro MAX
✓ Pubblicazione Google Maps
✓ Monetizzazione competenze

┌─────────────────────────────────┐
│ DEDUCIBILE 100%                 │
│ TAEG 0% - PayPal 3 rate         │
│ COMPATIBILE PNRR DM 66          │
└─────────────────────────────────┘

📦 PACCHETTI ENTI:
• Formazione Base: €980 (8h)
• Formazione + Tour: €1.499
• Pacchetto Scuola: €1.899 (16h)

🎁 OFFERTA: 1 Virtual Tour sede IN REGALO

📞 Riccardo Rossi
WhatsApp: +39 327 383 9782
schedabusiness.it`;

// EMAIL SCUOLE
const emailScuole = `OGGETTO: Candidatura Formatore Esterno - Transizione Digitale DM 66/2023

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

Spett.le Dirigente Scolastico,

mi candido come FORMATORE ESTERNO per DM 66/2023.

👤 CHI SONO:
Riccardo Rossi - Google Street View Certified 2016
• 7.000+ foto Google Maps
• 52 MILIONI views
• "Influencer silente su Google"

📚 MODULO PROPOSTO:
"Diventa il Google Photographer di domani"

Competenze DigComp 2.2:
• Alfabetizzazione digitale
• Creazione contenuti
• Problem solving

Contenuti:
1. Diventare Fotografo Google Certificato
2. Riprese 360° (GoPro MAX)
3. Monetizzazione competenze

💰 Compenso: In linea DM 66 (€122/h lordo)

🎁 BONUS: Virtual Tour scuola IN REGALO

📞 +39 327 383 9782
schedabusiness.it`;

export default function Roadmap() {
  const navigate = useNavigate();
  const [copiedEmail, setCopiedEmail] = useState(null);
  const [expandedSections, setExpandedSections] = useState({
    agenzie: true,
    enti: false,
    email: false
  });

  const copyToClipboard = (text, id) => {
    navigator.clipboard.writeText(text);
    setCopiedEmail(id);
    setTimeout(() => setCopiedEmail(null), 2000);
  };

  const copyAllEmails = (list) => {
    const emails = list.filter(i => i.email).map(i => i.email).join(", ");
    navigator.clipboard.writeText(emails);
    setCopiedEmail("all-" + list[0]?.name);
    setTimeout(() => setCopiedEmail(null), 2000);
  };

  const toggleSection = (section) => {
    setExpandedSections(prev => ({ ...prev, [section]: !prev[section] }));
  };

  const ContactBadge = ({ item }) => (
    <div className="flex flex-wrap gap-1 mt-2">
      {item.email && (
        <button
          onClick={() => copyToClipboard(item.email, item.email)}
          className="flex items-center gap-1 px-2 py-1 rounded-full bg-[#F8F9FA] text-[10px] hover:bg-[#E8F0FE] transition-all"
        >
          {copiedEmail === item.email ? <CheckCircle className="w-3 h-3 text-[#34A853]" /> : <Mail className="w-3 h-3 text-[#5F6368]" />}
          <span className="truncate max-w-[150px]">{item.email}</span>
        </button>
      )}
      {item.phone && (
        <a href={`tel:${item.phone}`} className="flex items-center gap-1 px-2 py-1 rounded-full bg-[#F8F9FA] text-[10px] hover:bg-[#E6F4EA]">
          <Phone className="w-3 h-3 text-[#5F6368]" /> {item.phone}
        </a>
      )}
    </div>
  );

  return (
    <div className="min-h-screen bg-[#080A0E] text-white py-6 px-4">
      <div className="max-w-6xl mx-auto">
        
        {/* HEADER */}
        <motion.div 
          className="text-center mb-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <div className="flex justify-center gap-2 mb-4">
            <span className="px-3 py-1 rounded-full bg-[#EA4335] text-xs font-bold">ROADMAP COMPLETA</span>
            <span className="px-3 py-1 rounded-full bg-[#34A853] text-xs font-bold">DEDUCIBILE 100%</span>
            <span className="px-3 py-1 rounded-full bg-[#4285F4] text-xs font-bold">TAEG 0%</span>
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold mb-2">
            🚀 Piano d'Azione Commerciale
          </h1>
          <p className="text-[#A1A5B0] max-w-2xl mx-auto">
            Tutto in un unico posto: <strong>30+ agenzie</strong> • <strong>10+ enti</strong> • <strong>3 email pronte</strong>
          </p>
          
          {/* Stats */}
          <div className="grid grid-cols-4 gap-3 mt-6 max-w-2xl mx-auto">
            <div className="p-3 rounded-xl bg-[#12161F] border border-white/10">
              <div className="text-xl font-bold text-[#4285F4]">3 MLD</div>
              <div className="text-[10px] text-[#A1A5B0]">Mercato e-Learning</div>
            </div>
            <div className="p-3 rounded-xl bg-[#12161F] border border-white/10">
              <div className="text-xl font-bold text-[#EA4335]">44 MLD</div>
              <div className="text-[10px] text-[#A1A5B0]">Mismatch/anno</div>
            </div>
            <div className="p-3 rounded-xl bg-[#12161F] border border-white/10">
              <div className="text-xl font-bold text-[#34A853]">€122/h</div>
              <div className="text-[10px] text-[#A1A5B0]">PNRR DM 66</div>
            </div>
            <div className="p-3 rounded-xl bg-[#12161F] border border-white/10">
              <div className="text-xl font-bold text-[#FBBC05]">100%</div>
              <div className="text-[10px] text-[#A1A5B0]">Deducibile</div>
            </div>
          </div>
        </motion.div>

        {/* ==================== SEZIONE AGENZIE ==================== */}
        <motion.div 
          className="mb-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.1 }}
        >
          <button 
            onClick={() => toggleSection('agenzie')}
            className="w-full flex items-center justify-between p-4 rounded-xl bg-[#12161F] border border-white/10 hover:border-[#4285F4]/50 transition-all"
          >
            <div className="flex items-center gap-3">
              <Building2 className="w-6 h-6 text-[#4285F4]" />
              <div className="text-left">
                <h2 className="text-lg font-bold">🏠 Agenzie Immobiliari Italia</h2>
                <p className="text-xs text-[#A1A5B0]">{franchising.length + luxury.length + portali.length + toscana.length} contatti • Franchising, Luxury, Online, Toscana</p>
              </div>
            </div>
            {expandedSections.agenzie ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
          </button>
          
          {expandedSections.agenzie && (
            <div className="mt-4 space-y-4">
              {/* Franchising */}
              <div className="p-4 rounded-xl bg-[#12161F] border border-white/10">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="font-bold text-[#4285F4] flex items-center gap-2">
                    <Building2 className="w-4 h-4" /> Franchising Nazionali ({franchising.length})
                  </h3>
                  <Button size="sm" variant="outline" className="text-xs h-7 border-[#4285F4] text-[#4285F4]" onClick={() => copyAllEmails(franchising)}>
                    <Copy className="w-3 h-3 mr-1" /> Copia Email
                  </Button>
                </div>
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2">
                  {franchising.map((a, i) => (
                    <div key={i} className="p-3 rounded-lg bg-black/30 border border-white/5">
                      <div className="font-medium text-sm">{a.name}</div>
                      <div className="text-[10px] text-[#A1A5B0]">{a.agencies} agenzie</div>
                      <ContactBadge item={a} />
                    </div>
                  ))}
                </div>
              </div>

              {/* Luxury */}
              <div className="p-4 rounded-xl bg-gradient-to-r from-[#FBBC05]/10 to-transparent border border-[#FBBC05]/30">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="font-bold text-[#FBBC05] flex items-center gap-2">
                    <Crown className="w-4 h-4" /> Luxury ({luxury.length})
                  </h3>
                  <Button size="sm" variant="outline" className="text-xs h-7 border-[#FBBC05] text-[#FBBC05]" onClick={() => copyAllEmails(luxury)}>
                    <Copy className="w-3 h-3 mr-1" /> Copia Email
                  </Button>
                </div>
                <div className="grid sm:grid-cols-2 gap-2">
                  {luxury.map((a, i) => (
                    <div key={i} className="p-3 rounded-lg bg-black/30 border border-[#FBBC05]/20">
                      <div className="font-medium text-sm">{a.name}</div>
                      <div className="text-[10px] text-[#FBBC05]">{a.location}</div>
                      <ContactBadge item={a} />
                    </div>
                  ))}
                </div>
              </div>

              {/* Portali */}
              <div className="p-4 rounded-xl bg-[#12161F] border border-white/10">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="font-bold text-[#34A853] flex items-center gap-2">
                    <Globe className="w-4 h-4" /> Portali Online ({portali.length})
                  </h3>
                  <Button size="sm" variant="outline" className="text-xs h-7 border-[#34A853] text-[#34A853]" onClick={() => copyAllEmails(portali)}>
                    <Copy className="w-3 h-3 mr-1" /> Copia Email
                  </Button>
                </div>
                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-2">
                  {portali.map((a, i) => (
                    <div key={i} className="p-3 rounded-lg bg-black/30 border border-white/5">
                      <div className="font-medium text-sm">{a.name}</div>
                      <div className="text-[10px] text-[#34A853]">{a.note}</div>
                      <ContactBadge item={a} />
                    </div>
                  ))}
                </div>
              </div>

              {/* Toscana */}
              <div className="p-4 rounded-xl bg-[#12161F] border border-white/10">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="font-bold text-[#EA4335] flex items-center gap-2">
                    <MapPin className="w-4 h-4" /> Toscana Locale ({toscana.length})
                  </h3>
                  <Button size="sm" variant="outline" className="text-xs h-7 border-[#EA4335] text-[#EA4335]" onClick={() => copyAllEmails(toscana)}>
                    <Copy className="w-3 h-3 mr-1" /> Copia Email
                  </Button>
                </div>
                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-2">
                  {toscana.map((a, i) => (
                    <div key={i} className="p-3 rounded-lg bg-black/30 border border-white/5">
                      <div className="font-medium text-sm">{a.name}</div>
                      <div className="text-[10px] text-[#EA4335]">{a.location}</div>
                      <ContactBadge item={a} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </motion.div>

        {/* ==================== SEZIONE ENTI ==================== */}
        <motion.div 
          className="mb-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          <button 
            onClick={() => toggleSection('enti')}
            className="w-full flex items-center justify-between p-4 rounded-xl bg-[#12161F] border border-white/10 hover:border-[#34A853]/50 transition-all"
          >
            <div className="flex items-center gap-3">
              <Landmark className="w-6 h-6 text-[#34A853]" />
              <div className="text-left">
                <h2 className="text-lg font-bold">🏛️ Enti Pubblici & Fondazioni</h2>
                <p className="text-xs text-[#A1A5B0]">{regioneToscana.length + fondazioni.length + scuole.length} contatti • Regione, Fondazioni, Scuole PNRR</p>
              </div>
            </div>
            {expandedSections.enti ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
          </button>
          
          {expandedSections.enti && (
            <div className="mt-4 space-y-4">
              {/* Regione */}
              <div className="p-4 rounded-xl bg-[#12161F] border border-white/10">
                <h3 className="font-bold text-[#4285F4] flex items-center gap-2 mb-3">
                  <Landmark className="w-4 h-4" /> Regione Toscana
                </h3>
                <div className="grid gap-2">
                  {regioneToscana.map((e, i) => (
                    <div key={i} className="p-3 rounded-lg bg-black/30 border border-white/5 flex items-center justify-between">
                      <div>
                        <div className="font-medium text-sm">{e.name}</div>
                        <div className="text-[10px] text-[#4285F4]">{e.note}</div>
                      </div>
                      <ContactBadge item={e} />
                    </div>
                  ))}
                </div>
              </div>

              {/* Fondazioni */}
              <div className="p-4 rounded-xl bg-gradient-to-r from-[#FBBC05]/10 to-transparent border border-[#FBBC05]/30">
                <h3 className="font-bold text-[#FBBC05] flex items-center gap-2 mb-3">
                  <Award className="w-4 h-4" /> Fondazioni
                </h3>
                <div className="grid sm:grid-cols-2 gap-2">
                  {fondazioni.map((f, i) => (
                    <div key={i} className="p-3 rounded-lg bg-black/30 border border-[#FBBC05]/20">
                      <div className="font-medium text-sm">{f.name}</div>
                      <div className="text-[10px] text-[#FBBC05] font-medium">{f.bando}</div>
                      <ContactBadge item={f} />
                    </div>
                  ))}
                </div>
              </div>

              {/* Scuole */}
              <div className="p-4 rounded-xl bg-[#12161F] border border-white/10">
                <div className="p-3 rounded-lg bg-[#34A853]/10 border border-[#34A853]/30 mb-3">
                  <div className="text-sm font-medium text-[#34A853]">💡 PNRR DM 66: Le scuole pagano €122/ora lordo per formatori esterni!</div>
                </div>
                <h3 className="font-bold text-[#34A853] flex items-center gap-2 mb-3">
                  <GraduationCap className="w-4 h-4" /> Scuole PNRR
                </h3>
                <div className="grid gap-2">
                  {scuole.map((s, i) => (
                    <div key={i} className="p-3 rounded-lg bg-black/30 border border-white/5">
                      <div className="font-medium text-sm">{s.name}</div>
                      <div className="text-[10px] text-[#34A853]">{s.note}</div>
                      <ContactBadge item={s} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </motion.div>

        {/* ==================== SEZIONE EMAIL ==================== */}
        <motion.div 
          className="mb-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          <button 
            onClick={() => toggleSection('email')}
            className="w-full flex items-center justify-between p-4 rounded-xl bg-[#12161F] border border-white/10 hover:border-[#EA4335]/50 transition-all"
          >
            <div className="flex items-center gap-3">
              <Mail className="w-6 h-6 text-[#EA4335]" />
              <div className="text-left">
                <h2 className="text-lg font-bold">📧 Email Pronte all'Invio</h2>
                <p className="text-xs text-[#A1A5B0]">3 template • Agenzie, Enti, Scuole PNRR</p>
              </div>
            </div>
            {expandedSections.email ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
          </button>
          
          {expandedSections.email && (
            <div className="mt-4 space-y-4">
              {/* Email Agenzie */}
              <div className="rounded-xl overflow-hidden border border-[#4285F4]/30">
                <div className="bg-[#4285F4] px-4 py-2 flex items-center justify-between">
                  <span className="font-medium text-sm">📧 Email Agenzie Immobiliari</span>
                  <Button size="sm" className={`h-7 text-xs ${copiedEmail === 'agenzie' ? 'bg-[#34A853]' : 'bg-white text-[#4285F4]'}`} onClick={() => copyToClipboard(emailAgenzie, 'agenzie')}>
                    {copiedEmail === 'agenzie' ? <CheckCircle className="w-3 h-3 mr-1" /> : <Copy className="w-3 h-3 mr-1" />}
                    {copiedEmail === 'agenzie' ? 'Copiato!' : 'Copia'}
                  </Button>
                </div>
                <pre className="p-4 text-xs text-[#A1A5B0] whitespace-pre-wrap font-mono max-h-48 overflow-y-auto bg-black/50">
                  {emailAgenzie}
                </pre>
              </div>

              {/* Email Enti */}
              <div className="rounded-xl overflow-hidden border border-[#EA4335]/30">
                <div className="bg-[#EA4335] px-4 py-2 flex items-center justify-between">
                  <span className="font-medium text-sm">🏛️ Email Enti & Fondazioni</span>
                  <Button size="sm" className={`h-7 text-xs ${copiedEmail === 'enti' ? 'bg-[#34A853]' : 'bg-white text-[#EA4335]'}`} onClick={() => copyToClipboard(emailEnti, 'enti')}>
                    {copiedEmail === 'enti' ? <CheckCircle className="w-3 h-3 mr-1" /> : <Copy className="w-3 h-3 mr-1" />}
                    {copiedEmail === 'enti' ? 'Copiato!' : 'Copia'}
                  </Button>
                </div>
                <pre className="p-4 text-xs text-[#A1A5B0] whitespace-pre-wrap font-mono max-h-48 overflow-y-auto bg-black/50">
                  {emailEnti}
                </pre>
              </div>

              {/* Email Scuole */}
              <div className="rounded-xl overflow-hidden border border-[#34A853]/30">
                <div className="bg-[#34A853] px-4 py-2 flex items-center justify-between">
                  <span className="font-medium text-sm">🎓 Email Scuole PNRR DM 66</span>
                  <Button size="sm" className={`h-7 text-xs ${copiedEmail === 'scuole' ? 'bg-[#4285F4]' : 'bg-white text-[#34A853]'}`} onClick={() => copyToClipboard(emailScuole, 'scuole')}>
                    {copiedEmail === 'scuole' ? <CheckCircle className="w-3 h-3 mr-1" /> : <Copy className="w-3 h-3 mr-1" />}
                    {copiedEmail === 'scuole' ? 'Copiato!' : 'Copia'}
                  </Button>
                </div>
                <pre className="p-4 text-xs text-[#A1A5B0] whitespace-pre-wrap font-mono max-h-48 overflow-y-auto bg-black/50">
                  {emailScuole}
                </pre>
              </div>
            </div>
          )}
        </motion.div>

        {/* CTA FINALE */}
        <motion.div 
          className="p-6 rounded-2xl bg-gradient-to-r from-[#4285F4] to-[#34A853] text-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          <h3 className="text-xl font-bold mb-2">🎯 Ora hai tutto. Parti!</h3>
          <p className="text-sm opacity-90 mb-4">52 milioni di views. 7000 foto. 9 anni. Niente balletti, solo risultati.</p>
          <div className="flex flex-wrap gap-3 justify-center">
            <a href="https://wa.me/+393273839782" target="_blank" rel="noopener noreferrer">
              <Button className="bg-white text-[#34A853] hover:bg-white/90 rounded-full">
                <MessageCircle className="w-4 h-4 mr-2" /> WhatsApp
              </Button>
            </a>
            <a href="https://schedabusiness.it" target="_blank" rel="noopener noreferrer">
              <Button variant="outline" className="border-white text-white hover:bg-white/10 rounded-full">
                <Globe className="w-4 h-4 mr-2" /> schedabusiness.it
              </Button>
            </a>
          </div>
        </motion.div>

        {/* Footer + Nav */}
        <div className="mt-6 border-t border-white/10 pt-4">
          <InternalNav />
        </div>
        <div className="mt-4 text-center text-xs text-[#5F6368]">
          <p>Riccardo Rossi • Fotografo Google Street View Certificato dal 2016</p>
          <p className="mt-1">+39 327 383 9782 • schedabusiness.it</p>
        </div>
      </div>
    </div>
  );
}
